<template>
    <div class="fieldBlock">
        <div class="group">
            <label>{{label}}</label>
            <div class="w50p">
                <span class="selectBox">
                    <label>{{getCcoName}}</label>
                    <select v-bind="modelValue" @change="$emit('update:modelValue', $event.target.value)">
                        <option v-for="info in choLst" :value="info.code" :selected="info.code==data" :key="info">{{info.name}}</option>
                    </select>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue'
export default {
    name: 'SelectBox',
    props: {
        label: String,
        choLst: Array,
        modelValue: String
    },
    setup(props) {
       const getCcoName = computed(() => props.choLst.find(cho => cho.code == props.modelValue).name);

       return {
           getCcoName
       }
    }
}
</script>